import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data.user))
        .catch(() => {
          // Token invalide ou expiré - nettoyer silencieusement
          localStorage.removeItem('token');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, mot_de_passe) => {
    const res = await api.post('/auth/login', { email, mot_de_passe });
    
    // Si email non vérifié, propager l'erreur avec les infos
    if (res.data.email_not_verified) {
      const error = new Error('Email non vérifié');
      error.emailNotVerified = true;
      error.email = res.data.email;
      throw error;
    }
    
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
  };

  const register = async (nom, email, mot_de_passe) => {
    const res = await api.post('/auth/register', { nom, email, mot_de_passe });
    
    // Si vérification email requise, ne pas connecter automatiquement
    if (res.data.email_verification_required) {
      return {
        emailVerificationRequired: true,
        email: res.data.email,
        message: res.data.message
      };
    }
    
    // Ancien comportement (si vérification désactivée)
    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
      setUser(res.data.user);
    }
    
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };
  
  const resendVerificationEmail = async (email) => {
    const res = await api.post('/auth/resend-verification', { email });
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, resendVerificationEmail }}>
      {children}
    </AuthContext.Provider>
  );
};
